import { Component, inject, OnInit, ViewChild, AfterViewInit, ViewEncapsulation, OnDestroy, HostListener, ChangeDetectorRef } from '@angular/core';
import { RouterLink, RouterOutlet, NavigationExtras,Router } from '@angular/router';
import { MasterService } from '../../service/master.service';
import { Observable,Subscription  } from 'rxjs';
import { Transaction } from '../../models/transaction';
import { AsyncPipe, TitleCasePipe, DatePipe, CommonModule } from '@angular/common';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MaterialModule } from '../../material.module';
import { GoogleChartsModule } from 'angular-google-charts';
import { format, parseISO } from 'date-fns';
import { ChartType } from 'angular-google-charts';
import { TransactionSummary } from '../../models/transaction-summary';
import { MatGridListModule } from '@angular/material/grid-list';
//import { FirebaseService } from '../../utility/service/firebaseService';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
//import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { BreakpointObserver as CdkBreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { FirebaseService } from '../../../../utility/service/firebase.service';
@Component({
  selector: 'app-dashbord',
  standalone: true,

  imports: [RouterOutlet,AsyncPipe,MaterialModule,TitleCasePipe,DatePipe,CommonModule,GoogleChartsModule,MatGridListModule,MatProgressSpinnerModule],
  templateUrl: './dashbord.component.html',
  styleUrl: './dashbord.component.css',
  encapsulation: ViewEncapsulation.None
})
export class DashbordComponent implements OnInit, AfterViewInit, OnDestroy  {

  gridCols = 2;
  isMobile = false;
  breakpointSub!: Subscription;
  listSubRef : any = null;
  imagePath: string = 'assets/img/auresscan.jpg'; 
 transaction:Transaction[]=[];
 fileList: any = [];
 txnNumber:string='';
 maskedString:string='';
  transaction$: Observable<Transaction[]>= new Observable<Transaction[]>();
  summary$!: Observable<TransactionSummary>;
  masterSer= inject(MasterService);
  fireDBService=inject(FirebaseService);
  loading = true;
  //cdr: ChangeDetectorRef;
  displayedColumns: string[] = ['txnNum', 'txnOperation', 'creationDate', 'senderHex', 'receiverHex','txnType','coinsqty','totalAmountTxn'];
  dataSource = new MatTableDataSource<Transaction>();
  constructor(private router: Router,private breakpointObserver: CdkBreakpointObserver,fireDBService: FirebaseService,private cdr: ChangeDetectorRef) {}
  @ViewChild('desktopPaginator') desktopPaginator?:MatPaginator;
  @ViewChild('mobilePaginator') mobilePaginator?:MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  chartType = ChartType.LineChart;
  chartColumns = ['Date', 'Amount'];
  chartData: any[] = [];
  chartOptions: any = {};
  setChartOptions(): void {
    this.chartOptions = {
      title: 'Last 7 Days Total',
      titlePosition: 'center', 
      titleTextStyle: {
        fontName: 'Menlo Consolas',
        fontSize: 16
      },
      hAxis: {
        title: 'Date',
        showTextEvery: 1,
        textStyle: { fontSize: 12 }
      },
      vAxis: {
        title: 'Amount',
        gridlines: { color: 'transparent' },
        minValue: 0,
        format: 'short',
        legend: 'true'
        
      },
      pointSize: 5,
      legend: { position: 'none' }, 
      curveType: 'function',
      backgroundColor: 'transparent',
      chartArea: { width: '80%', height: '70%',left: 50,top:40 },
      
    };
  }
  loadChartData(): void {
    this.masterSer.getDailyTotals().subscribe((data: any[]) => {
      this.chartData = data.map((item: any) => {
        const label = format(parseISO(item.date), 'MMM dd'); // X-axis label
        const amount =parseFloat(item.total) || 0; // ✅ ensure number, default 0
        return [label, amount];
      });
    });
  }
  ngAfterViewInit(): void {
   // setTimeout(() => this.assignPaginator(), 0);
    
    // this.masterSer.getDailyTotals().subscribe((data:any[]) => {
    //   this.chartData = data.map((item: any) => {
    //     const label = format(parseISO(item.date), 'MMM dd');
    //     //const displayLabel = this.customTicks.has(label) ? label : ''; // show only selected dates
    //     return [label, item.total];
    //   });
    // });



  }
 getUpdateNodevalue():void{

  let nodePath = `transactions/dataUpdatedByMobile/`;
 
  this.listSubRef = this.fireDBService.getFirebaseListTypeValues(nodePath).subscribe((res:any) => {
    console.log(res);
  //  this.spinner.hide();
    this.fileList = res;
    if(this.fileList && this.fileList.length > 0) {
     // alert("Hello1");
      this.getAllDashbordData();
      // this.fileList = this.fileList.sort((a:any, b:any) => {
      //   return a['creationDate'] < b['creationDate'] ? 1: -1;
      // })
    }else{
     // alert("Hello");
      this.getAllDashbordData();
    }
    //this.dataSource.data = this.fileList;
  })

 }
  ngOnInit(): void {

    this.getUpdateNodevalue();
    //this.getAllDashbordData();
   // debugger
 // Observe breakpoints
 
  }

  getAllDashbordData():void{

    
   
      this.summary$ = this.masterSer.getSummary();
      this.summary$.subscribe((summary:TransactionSummary)=> {
        console.log('Summary Response:', summary);
      });
  
    
      this.masterSer.getAllTransaction().subscribe((data: Transaction[]) => {
        this.dataSource.data = data;
        //this.dataSource.paginator = this.paginator;
       
         this.dataSource.sort = this.sort;
       
        //  if (this.paginator) {
        //   alert("Hello Desktop")
        //   this.dataSource.paginator = this.paginator;
        // } else if (this.mobilePaginator) {
        //   alert("Hello Mobile")
        //   this.dataSource.paginator = this.mobilePaginator;
        // }
//this.setChartOptions();
     //   this.loadChartData();
        this.loading=false
        this.breakpointSub = this.breakpointObserver.observe(['(max-width: 768px)'])
    .subscribe(result => {
     this.gridCols = result.matches ? 1 : 2;
      this.isMobile = result.matches;
     // this.dataSource.paginator = this.mobilePaginator;
    //  this.cdr.detectChanges();
    //     setTimeout(() => this.assignPaginator(), 0);
    //   )
   // alert("JJJJJJJJJJJJJJ");
    setTimeout(() => this.assignPaginator(), 0);
    //setTimeout(() => this.assignPaginator(), 0);
    //this.dataSource.sort = this.sort;
    });
      });
  
  

  }
  assignPaginator(): void {
//alert(this.isMobile)

  //  const paginatorToUse = this.isMobile ? this.mobilePaginator:this.desktopPaginator;
     
    const paginatorToUse =this.isMobile
    ? this.mobilePaginator ?? this.desktopPaginator
    : this.desktopPaginator ?? this.mobilePaginator;
   // alert(paginatorToUse);
    if (paginatorToUse) {
      this.dataSource.paginator = paginatorToUse;
      this.dataSource._updateChangeSubscription();
    } 
    
    
    else {
      console.warn(
        'Paginator not available yet. isMobile:',
        this.isMobile,
        'desktop:',
        !!this.desktopPaginator,
        'mobile:',
        !!this.mobilePaginator
      );
    }
  }
  applyFilter(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.dataSource.filter = value.trim().toLowerCase();
    this.dataSource.paginator?.firstPage();
  }
// getAllTransaction(){
//   this.transaction$=this.masterSer.getAllTransaction();
//  console.log(this.transaction$);
// }
//ngOnInit():void{
 // this.getAllTransaction();
// this.masterSer.getAllTransaction().subscribe({
//   next: (data:any) => this.transaction = data,
//    error: (err:any) => console.error('Error fetching users:', err)
  
   
// });
 //};

 getMaskedString(fullString: string | null | undefined): string {
  if (!fullString || typeof fullString !== 'string') {
    return 'Invalid value';
  }

  if (fullString.length <= 20) {
    return fullString;
  } else {
    const first10 = fullString.slice(0, 10);
    const last10 = fullString.slice(-10);
    return `${first10}...${last10}`;
  }
}

getMaskedRightPart(fullString: string | null | undefined): string {
  if (!fullString || typeof fullString !== 'string') {
    return 'Invalid format';
  }

  const parts = fullString.split('-');
  if (parts.length > 1) {
    const rightSide = (parts[1] ?? '').trim(); 
    const first15 = rightSide.slice(0, 15);
    return `${first15}...`;
  } else {
    return 'Invalid format';
  }
 
}

getTransactionMethod(methodName:string, redeemedGoldName:string){
  if(methodName=='Transfer'){
    return 'Tfr';
  }else if(methodName=='Delivery'){
    if(redeemedGoldName==''||redeemedGoldName == null)
    redeemedGoldName=methodName;
    return redeemedGoldName;
  }
  return methodName;
}

getPriceWithCoinUnit(price:string,coinUnit: string,operationType:string ):string{
  console.log(operationType);
 
  if(operationType=='conversion'){
    return  price+" "+'T';
  }else if(coinUnit=='crypto_coin'){
    return   price+" "+'AUR';
  }else if(coinUnit=='sona_coin'){
    return   price+" "+'AURYX';

  }else if(coinUnit=='usdc_coin'){
    return   price+" "+'USDD';

  }
   return price;
} 

getCoinType(coinValue:string): string{

 if(coinValue=='crypto_coin'){
    return  'AURYNT';
  }else if(coinValue=='sona_coin'){
    return  'AURYX GOLD';

  }else if(coinValue=='usdc_coin'){
    return 'SC/USDD';

  }
   return '';

}

formatNumberWithCommas(value: number | null | undefined): string {
  if (value === null || value === undefined || isNaN(Number(value))) {
    return '0.00';
  }

  return Number(value).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}


getMaskedRightPartWithoutDot(fullString:string): string {
  const parts = fullString.split('-');
  if (parts.length > 1) {
    const rightSide = parts[1].trim(); // "16546364271752824014869000"
    // const first15 = rightSide.slice(0, 15);
    return rightSide;
  } else {
    return 'Invalid format';
  }

 
}




clickTxnHashOnHTMLPage(valueStr:string):void{
 // alert(valueStr);
  this.txnNumber=valueStr;
 // console.log(valueStr);

  const navigationExtras: NavigationExtras = {
    queryParams:{txnNumber:this.txnNumber} ,
    skipLocationChange: true,
    state: {value: 1}
   }
    this.router.navigate(['/transactionDetails'],navigationExtras);
}
@HostListener('window:resize')
  onResize(): void {
 // this.setChartOptions(); // triggers redraw on resize
  // this.loadChartData();
   setTimeout(() => this.assignPaginator(), 0);

  // this. getAllDashbordData();
 //  this.dataSource.paginator = this.mobilePaginator;
    //this.ngOnInit();
  }
ngOnDestroy(): void {
  this.breakpointSub?.unsubscribe();
}



}

